import { useQuery } from '@tanstack/react-query';

// A document Siesta generated and presented in a conversation, attachable to its email drafts.
type GeneratedDocumentResponse = {
  fileId: number;
  fileName: string;
  fileSize: number | null;
  createdAt: string | null;
};

export function useConversationGeneratedDocuments(
  conversationId: string | undefined,
  enabled: boolean,
) {
  const { data, isLoading, isError } = useQuery<GeneratedDocumentResponse[]>({
    queryKey: ['conversations', conversationId, 'generated-documents'],
    enabled: enabled && !!conversationId,
    // A document presented moments ago must show up the next time the picker opens.
    staleTime: 0,
    // Flag-gating means a 404 when the feature is off; never retry it.
    retry: false,
  });
  return { generatedDocuments: isError ? [] : (data ?? []), isLoading, isError };
}
